export const aiModels = [
  'GPT_4_1_MINI',
  'GPT_O_4_MINI',
  'GPT_4_O_MINI',
  'GPT_O_3',
  'SONAR_PRO',
  'SONAR_REASONING_PRO',
  'SONAR',
  'SONAR_DEEP_RESEARCH',
  'GPT_5',
  'GPT_5_1',
  'GPT_5_MINI',
  'GPT_5_NANO',
  'N8N',
  'QWEN3_6_27B',
  'DEEPSEEK_R1_32B',
  'LLAMA3_LATEST',
  'GEMMA4_26B',
  'QWEN2_5_CODER_14B_INSTRUCT',
  'GEMMA3_27B',
  'CLAUDE_SONNET_4_6',
  'CLAUDE_SONNET_4_5',
  'CLAUDE_HAIKU_4_5',
  'CLAUDE_OPUS_4_8',
  'MINIMAX_M3',
  'MINIMAX_M2_7',
  'MINIMAX_M2_7_HIGHSPEED',
  'MINIMAX_M2_5',
  'MINIMAX_M2_5_HIGHSPEED',
  'MINIMAX_M2_1',
  'MINIMAX_M2_1_HIGHSPEED',
  'MINIMAX_M2',
];

export const modelMapping = {
  GPT_4_1_MINI: 'gpt-4.1-mini',
  GPT_O_4_MINI: 'o4-mini',
  GPT_4_O_MINI: 'gpt-4o-mini',
  GPT_O_3: 'o3',
  SONAR_PRO: 'sonar-pro',
  SONAR_REASONING_PRO: 'sonar-reasoning-pro',
  SONAR: 'sonar',
  SONAR_DEEP_RESEARCH: 'sonar-deep-research',
  GPT_5: 'gpt-5-2025-08-07',
  GPT_5_1: 'GPT-5.1',
  GPT_5_MINI: 'gpt-5-mini',
  GPT_5_NANO: 'gpt-5-nano',
  N8N: 'n8n',
  QWEN3_6_27B: 'qwen3.6:27b',
  DEEPSEEK_R1_32B: 'deepseek-r1:32b',
  LLAMA3_LATEST: 'llama3:latest',
  GEMMA4_26B: 'gemma4:26b',
  QWEN2_5_CODER_14B_INSTRUCT: 'qwen2.5-coder:14b-instruct',
  GEMMA3_27B: 'gemma3:27b',
  CLAUDE_SONNET_4_6: 'claude-sonnet-4-6',
  CLAUDE_SONNET_4_5: 'claude-sonnet-4-5',
  CLAUDE_HAIKU_4_5: 'claude-haiku-4-5-20251001',
  CLAUDE_OPUS_4_8: 'claude-opus-4-8',
  MINIMAX_M3: 'MiniMax-M3',
  MINIMAX_M2_7: 'MiniMax-M2.7',
  MINIMAX_M2_7_HIGHSPEED: 'MiniMax-M2.7-highspeed',
  MINIMAX_M2_5: 'MiniMax-M2.5',
  MINIMAX_M2_5_HIGHSPEED: 'MiniMax-M2.5-highspeed',
  MINIMAX_M2_1: 'MiniMax-M2.1',
  MINIMAX_M2_1_HIGHSPEED: 'MiniMax-M2.1-highspeed',
  MINIMAX_M2: 'MiniMax-M2',
};
